import { useState } from 'react';
import '../../styles/navbar.css';
import srkLogo from '../../assets/images/logo/srk_logo.jpeg';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top shadow-sm">
      <div className="container-fluid px-4">
        {/* Logo */}
        <a className="navbar-brand" href="/">
          <img src={srkLogo} alt="SRK Logo" height="50" />
        </a>

        {/* Hamburger Button */}
        <button 
          className="navbar-toggler border-0" 
          type="button" 
          onClick={toggleMenu}
          aria-controls="navbarNav" 
          aria-expanded={isOpen}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation Menu */}
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto gap-4">
            <li className="nav-item">
              <a className="nav-link" href="/events" onClick={() => setIsOpen(false)}>
                Events
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/about" onClick={() => setIsOpen(false)}>
                About
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/contact" onClick={() => setIsOpen(false)}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
